export const CART_DRAWER_EVENT = 'cart-drawer-open';
export const openCartDrawer = (productId = null) => window.dispatchEvent(new CustomEvent(CART_DRAWER_EVENT, { detail: { productId } }));
